module.exports = __webpack_public_path__ + "img/minfo.0aa6313e.png";